import React from 'react';
import { Caption as CaptionTypigraphy } from '../../../typography';
import { formatFileSize } from '../../utils';
export const Caption = ({ caption, maxSize }) => {
    if (maxSize && !caption) {
        return React.createElement(CaptionTypigraphy, null, `Max. File Size: ${formatFileSize(maxSize)}`);
    }
    if (!caption)
        return null;
    if (typeof caption === 'function') {
        const CustomCaption = caption;
        return React.createElement(CustomCaption, null);
    }
    return React.createElement(CaptionTypigraphy, null, caption);
};
